import { serviceNotifications } from "./serviceNotifications";
import { WSNotificationResponse } from "../../modules/Dashboard/components/Notifications";

export const getNotifications = async (): Promise<WSNotificationResponse[]> => {
  const { data } = await serviceNotifications.get("/in-app");

  return data;
};
